import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../../Component/Spinner/Spinner';
import { AuthContext } from '../../Context/UseContext';
import toast from "react-hot-toast";
import { useAdmin } from '../../hooks/useUser';

const AdminRoute = ({children}) => {
    const { user, loading } = useContext(AuthContext);
    const [isAdmin, isAdminLoading] = useAdmin(user?.email);
    const location = useLocation();

    if (loading || isAdminLoading) {
        return <Spinner />
    }

    if (user && isAdmin) {
        return children;
    }
    return (
        <>
        <Navigate to="/login" state={{ from: location }} replace></Navigate>;
            {toast.error("You are not authorized to access this page")}
        </>
    )
};

export default AdminRoute;